import api from '../..'

const getExternalCourse = (externalCourseId: number | string) => {
  return api
    .get(`administration/external_courses/${externalCourseId}`)
    .then(({ data }) => {
      return data.data.attributes
    })
}

export default getExternalCourse
